import React from 'react'

// TODO: would be nice to pull values out of `review` and incude them as individual props

const ReminderThankYouScreen = ({
  review,
  email,
  productTitle,
  productImageUrl,
  reminderDate,
}) => {
  return (
    <div className={`reminder-thankyou-screen`}>
      <div className="header">
        <h1
          dangerouslySetInnerHTML={{ __html: review.reminderThankyouHeader }}
        />
        <div
          className="intro"
          dangerouslySetInnerHTML={{ __html: review.reminderThankyouIntro }}
        />
      </div>

      <div className="detail">
        <div className="image">
          <img src={productImageUrl} alt="" />
        </div>
        <div className="copy">
          <p>Email reminder set</p>
          <p>{email}</p>
          <p
            className="copy-product"
            dangerouslySetInnerHTML={{ __html: productTitle }}
          />
          <p>You'll get a reminder email in a week!</p>
        </div>
      </div>

      <div className="body">
        <div
          className="copy"
          dangerouslySetInnerHTML={{ __html: review.reminderThankyouBody }}
        />
        {review.reminderThankyouBodyButton && (
          <a
            className="btn"
            role="button"
            target="_blank"
            rel="noreferrer"
            href={review.reminderThankyouBodyButtonUrl}
          >
            {review.reminderThankyouBodyButton}
          </a>
        )}
      </div>
    </div>
  )
}

export default ReminderThankYouScreen
